import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Alert, Box, Snackbar, Stack, TextField } from '@mui/material';
import { FlowBreadcrumbs, FlowFormCard, SubmitButton, mediaBaseUrl, mediaPreviewStyles } from './FlowLayout';

const AddEditContinent = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [continentData, setContinentData] = useState({
    continent: '',
    continent_heading: '',
    continent_description: '',
    continent_banner: ''
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  useEffect(() => {
    if (id) {
      axios.get(`https://aaryanholidays.in/backend/continents/${id}`)
        .then((response) => setContinentData(response.data))
        .catch((error) => console.error('Error fetching continent data:', error));
    }
  }, [id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    const formData = new FormData();
    formData.append('continent', continentData.continent);
    formData.append('continent_heading', continentData.continent_heading);
    formData.append('continent_description', continentData.continent_description);
    if (selectedFile) {
      formData.append('continent_banner', selectedFile);
    }

    try {
      if (id) {
        await axios.put(`https://aaryanholidays.in/backend/continents/${id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        await axios.post('https://aaryanholidays.in/backend/continents', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }

      setSnackbarMessage(`Continent ${id ? 'updated' : 'added'} successfully.`);
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      navigate('/manage-continents');
    } catch (error) {
      setSnackbarMessage('There was an error saving the continent.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      console.error('There was an error saving the continent!', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box>
      <FlowBreadcrumbs items={[{ label: 'Tour Management', to: '/manage-continents' }, { label: 'Continents', to: '/manage-continents' }, { label: id ? 'Edit Continent' : 'Add Continent' }]} />
      <FlowFormCard
        title={id ? 'Edit Continent' : 'Add Continent'}
        subtitle="Create the parent travel region with a strong title, supporting description, and clean visual banner."
      >
        <form onSubmit={handleSubmit}>
          <Stack spacing={2.5}>
            <TextField label="Continent Name" value={continentData.continent} onChange={(e) => setContinentData({ ...continentData, continent: e.target.value })} fullWidth required />
            <TextField label="Continent Heading" value={continentData.continent_heading} onChange={(e) => setContinentData({ ...continentData, continent_heading: e.target.value })} fullWidth required />
            <TextField label="Continent Description" value={continentData.continent_description} onChange={(e) => setContinentData({ ...continentData, continent_description: e.target.value })} fullWidth multiline rows={5} required />
            <Box>
              <input id="continent-banner" type="file" hidden onChange={(e) => setSelectedFile(e.target.files[0])} />
              <label htmlFor="continent-banner">
                <SubmitButton component="span" variant="outlined">
                  Upload Banner
                </SubmitButton>
              </label>
            </Box>
            {(selectedFile || continentData.continent_banner) ? (
              <img
                src={selectedFile ? URL.createObjectURL(selectedFile) : `${mediaBaseUrl}${continentData.continent_banner}`}
                alt="Continent banner preview"
                style={mediaPreviewStyles}
              />
            ) : null}
            <SubmitButton type="submit" variant="contained" loading={submitting}>
              {id ? 'Update Continent' : 'Create Continent'}
            </SubmitButton>
          </Stack>
        </form>
      </FlowFormCard>
      <Snackbar open={openSnackbar} autoHideDuration={4000} onClose={() => setOpenSnackbar(false)}>
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddEditContinent;
